/* global navigator */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { routes } from 'core/App';
import axios from 'axios';
import ConfigService from 'core/config';
import i18n from './i18n';

const getRandom = () => Math.floor(Math.random() * 100000);

const rootElement = document.getElementById('root');
const root = rootElement ? createRoot(rootElement) : null;

// Create the router with the routes configuration
const router = createBrowserRouter(routes);

const render = () => {
  if (!root) {
    return;
  }

  root.render(<RouterProvider router={router} />);
};
const getLanguage = () => {
  let language = navigator.languages?.[0] || navigator.language || navigator.userLanguage;

  // language would be something like en-EN or en_EN
  // However we store our files with format en.json
  // therefore retrieve only the first 2 characters
  if (language.length > 2) {
    [language] = language.split('-');
    [language] = language.split('_');
  }

  return language;
};
const languagePath = '/src/locale';
const getDefault = () => axios.get(`${languagePath}/en.json?v=${getRandom()}`);

const requestLanguage = () =>
  getDefault().then((response) => {
    i18n.addResourceBundle('en', 'translation', response.data);
    return response;
  });
// Only english supported for the moment, will use this when more languages are supported
// axios.get(`${languagePath}/${getLanguage()}.json?v=${getRandom()}`)
//   .then((response) => {
//     i18n.addResourceBundle(getLanguage(), 'translation', response.data);
//     return response;
//   })
//   .catch((error) => {
//     //  we don't have the language file, set to English
//     if (error.response && error.response.status === 404) {
//       getDefault().then((response) => {
//         i18n.addResourceBundle('en', 'translation', response.data);
//         render();
//       });
//     }
//     console.log(error);
//     return error;
//   });

const getConfig = () => axios.get('/src/config.json');

try {
  const response = await axios.all([requestLanguage(), getConfig()]);

  ConfigService.config = response[1].data;
  render();
} catch (error) {
  console.error('Error loading configuration:', error);
}
